import { createApp } from "vue";
import App from "./App.vue"; // root
import router from "./router"; // router

const app = createApp(App).use(router);

// import VConsole from "vconsole";
// const vConsole = new VConsole();

// vant
import "vant/lib/index.css";

// util
import util from "./assets/util";
app.config.globalProperties.util = util;

// i18n
import { createI18n } from "vue-i18n";
import messages from "./i18n/messages";

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: util.language("text") || "zh", // set locale
    fallbackLocale: ["en", "tw"], // set fallback locale
    messages: messages, // set locale messages
});
app.use(i18n);

// download plugin
import download from "./assets/download";
app.use(download);

import hevueImgPreview from 'hevue-img-preview/v3'
app.use(hevueImgPreview, {
    arrowBtn: false,
    thumbnail: true,
    closeBtn: false,
    controlBar: ['rotateRight', 'download', 'prev', 'next'],
})

app.mount("#app");
